import React from 'react';
import { Modal, Button, Space, Table } from 'antd';

const ClauseDetailModal = ({ open, onClose, meta, event }) => {
  return (
    <Modal
      title={
        event
          ? `Triggered clauses — ${event.ticker}`
          : 'Triggered clauses'
      }
      open={open}
      onCancel={onClose}
      footer={<Button onClick={onClose}>Close</Button>}
      width={840}
    >
      {meta ? (
        <Space direction="vertical" style={{ width: '100%' }} size="middle">
          <div>
            {meta.label || `${meta.action || 'Trade'}`}
            {meta.clause_ids?.length ? (
              <span style={{ marginLeft: 8 }}>
                ({meta.clause_ids.length > 1 ? 'Clauses' : 'Clause'}{' '}
                {meta.clause_ids.join(', ')})
              </span>
            ) : null}
          </div>
          {meta.clause_details?.length ? (
            <Table
              size="small"
              rowKey={(row, idx) => row.clause_id ?? idx}
              pagination={false}
              dataSource={meta.clause_details}
              columns={[
                {
                  title: 'Clause ID',
                  dataIndex: 'clause_id',
                  render: (val) => val ?? '—',
                },
                {
                  title: 'Field',
                  dataIndex: 'field',
                  render: (val, row) =>
                    row.clause_field_sourcetable
                      ? `${val || ''} @ ${row.clause_field_sourcetable}`
                      : val || '',
                },
                { title: 'Operator', dataIndex: 'operator' },
                {
                  title: 'Field value',
                  dataIndex: 'field_value',
                  render: (val) => (val !== null && val !== undefined ? Number(val).toFixed(4) : '—'),
                },
                {
                  title: 'Threshold',
                  dataIndex: 'threshold_value',
                  render: (val, row) => {
                    if (val !== null && val !== undefined) {
                      return Number(val).toFixed(4);
                    }
                    if (row.threshold_field) {
                      return row.threshold_field;
                    }
                    return '—';
                  },
                },
                {
                  title: 'Source',
                  render: (_, row) => {
                    if (row.threshold_source === 'literal') {
                      return 'Literal';
                    }
                    if (row.threshold_field) {
                      return `Dynamic (${row.threshold_field}${
                        row.threshold_sourcetable ? ` @ ${row.threshold_sourcetable}` : ''
                      })`;
                    }
                    return 'Dynamic';
                  },
                },
                {
                  title: 'Scope',
                  dataIndex: 'clause_scope',
                  render: (val) => (val && val !== 'any' ? val : 'any'),
                },
                {
                  title: 'Configured',
                  dataIndex: 'trade_direction',
                  render: (val) => (val ? val.toUpperCase() : 'BUY'),
                },
                {
                  title: 'Applied',
                  dataIndex: 'direction_applied',
                  render: (val) => (val ? val.toUpperCase() : 'BUY'),
                },
                {
                  title: 'Portfolio state',
                  dataIndex: 'in_portfolio',
                  render: (val) => (val ? 'Holding' : 'Not holding'),
                },
              ]}
            />
          ) : (
            <div style={{ color: '#999' }}>No clause proof data recorded for this trade.</div>
          )}
        </Space>
      ) : (
        <div style={{ color: '#999' }}>No clause proof data available.</div>
      )}
    </Modal>
  );
};

export default ClauseDetailModal;




